import { DateTime } from 'luxon';
import { FC } from 'react';

import { gettext } from 'medialoopster/Internationalization';
import { DateTimeInput } from 'medialoopster/components';

import useWidgetContext from '../hooks/useWidgetContext';

type Props = {
  readonly name: string;
  readonly label: string;
  readonly allowNull: boolean;
  readonly defaultValue: DateTime | null;
  readonly disabled?: boolean;
};

const DateTimeWidget: FC<Props> = ({
  name,
  label,
  allowNull,
  defaultValue,
  disabled = false,
}: Props) => {
  const { onChange, onBlur, value, error } = useWidgetContext({
    name,
    defaultValue,
    rules: {
      validate: (v) => {
        if (v === null && !allowNull) {
          return gettext('Please enter a date and time.');
        }
        if (v !== null && !v.isValid) {
          return gettext('Please enter a valid date and time.');
        }
        return true;
      },
    },
    disabled,
  });
  return (
    <DateTimeInput
      value={value}
      label={label}
      errorMsg={error}
      showError={!!error}
      onChange={onChange}
      onBlur={onBlur}
      readOnly={disabled}
    />
  );
};

export default DateTimeWidget;
